import ShipHero from '@/components/icons/ShipHero'
import ShipStation from '@/components/icons/ShipStation'
import ShipBob from '@/components/icons/ShipBob'
import ShippingEasy from '@/components/icons/ShippingEasy'
import Extensiv from '@/components/icons/Extensiv'
import Flexport from '@/components/icons/Flexport'
import AmazonMCFIcon from '@/components/icons/AmazonMCFIcon'
import FulfillmentLabIcon from '@/components/icons/FulfillmentLabIcon'
import ManualFulfillmentIcon from '@/components/icons/ManualFulfillmentIcon'
import Shopify from '@/components/icons/Shopify'

export const fulfillmentProviders = {
    shiphero: {
        name: 'ShipHero',
        type: 'shiphero',
        title: 'Login with ShipHero credentials',
        description:
            'The user you are logging in with must have the following permissions: Orders, Purchase Orders, Stores, Shipping, and Products.',
        link: 'https://shiphero.com/',
        icon: <ShipHero sx={{ width: 100, height: 30 }} />,
    },
    shipstation: {
        name: 'ShipStation',
        type: 'shipstation',
        link: 'https://www.shipstation.com/',
        icon: <ShipStation sx={{ width: 120, height: 30 }} />,
        title: 'API Key',
        description: `Follow the instructions at the link below to generate an API key.`,
        helperLinks: [
            {
                url: 'https://help.shipstation.com/hc/en-us/articles/360025856212-ShipStation-API#UUID-5a634fc3-0fbe-be8a-ff19-aca80615d6d6',
                text: 'Get your ShipStation API Token',
            },
        ],
    },
    shipbob: {
        name: 'ShipBob',
        type: 'shipbob',
        link: 'https://www.shipbob.com/',
        icon: <ShipBob sx={{ width: 120, height: 30 }} />,
        title: 'API Token',
        description: `Follow the instructions at the link below to generate an API token.`,
        helperLinks: [
            {
                url: 'https://support.shipbob.com/s/article/API-Token-Generation-Personal-Access-Token',
                text: 'Get your ShipBob API Token',
            },
        ],
    },
    manual_fulfillment: {
        name: 'Manual Fulfillment',
        type: 'manual_fulfillment',
        page_title: 'Manual Fulfillment',
        page_description:
            'When enabling Manual Fulfillment, this allows you to setup a Warehouse for shipping goods without connecting fulfillment software to our Platform. This can be used in conjunction with supported fulfillment integrations.',
        icon: <ManualFulfillmentIcon sx={{ width: 30, height: 30 }} />,
        show_name_on_list: true,
        hide_form_description: true,
    },
    extensiv: {
        name: 'Extensiv',
        type: 'extensiv',
        title: 'API Key',
        link: 'https://www.extensiv.com/',
        icon: <Extensiv sx={{ width: 110, height: 30 }} />,
        description: `Follow the link below to generate an API key. You must follow the instructions for the “Cart API Keys” to successfully complete the integration.`,
        helperLinks: [
            {
                url: 'https://help.extensiv.com/365906-api-documentation/1620385-how-to-get-extensiv-integration-manager-api-keys',
                text: 'Get your Extensive API Key',
            },
        ],
    },
    shippingeasy: {
        name: 'ShippingEasy',
        type: 'shippingeasy',
        title: 'API Key',
        description:
            'In order to connect your ShippingEasy account, you must create a new store and paste this Store URL into ShippingEasy and provide your API information. Please see the links below to find the values to enter.',
        icon: <ShippingEasy sx={{ width: 70, height: 30 }} />,
        helperLinks: [
            {
                url: 'https://support.shippingeasy.com/hc/en-us/articles/4406993201179-ShippingEasy-Open-API-Custom-Integration',
                text: 'Get your API Key',
            },
            {
                url: 'https://app4.shippingeasy.com/settings/api_credentials',
                text: 'Open API Credentials',
            },
            {
                url: 'https://app4.shippingeasy.com/settings/stores',
                text: 'Open Stores & Orders',
            },
        ],
    },
    fulfillment_lab: {
        title: 'Store Credentials',
        name: 'The Fulfillment Lab',
        type: 'fulfillment_lab',
        description: `Inside your The Fulfillment Lab account, you will need to first visit Settings --> Connected Stores section then create a new store and copy/paste the Store ID and Secret here. Then you will also need to enable the store to accept orders inside your TFL account (change false to true) and hit Save.`,
        icon: <FulfillmentLabIcon sx={{ width: 109, height: 'auto' }} />,
    },
    flexport: {
        name: 'Flexport',
        type: 'flexport',
        title: 'API Token',
        description: `In order to connect your Flexport account, you will need to visit the API Tokens page by following the link below, click "Generate API Token", click "Select all" for the Scopes, then paste that API Token here.`,
        icon: <Flexport sx={{ width: 109, height: 'auto' }} />,
        helperLinks: [
            {
                url: 'https://portal.flexport.com/settings/api-tokens',
                text: 'Get your Flexport API Token',
            },
        ],
    },
    amazon_mcf: {
        name: 'Amazon MCF',
        type: 'amazon_mcf',
        title: '',
        description: '',
        icon: <AmazonMCFIcon sx={{ width: '155px', height: '40px' }} />,
    },
    manual_input: {
        name: 'ShipStation',
        type: 'manual_input',
        link: 'https://www.shipstation.com/',
        icon: <ShipStation sx={{ width: 120, height: 30 }} />,
    },
    custom_provider: {
        type: 'custom_app_provider',
        icon: null,
    },
    shopify: {
        id: 'shopify',
        name: 'Shopify',
        type: 'shopify',
        title: 'Shopify Store Subdomain',
        icon: <Shopify sx={{ width: 100, height: 30 }} />,
    },
}

export const CONFIG_TYPES = {
    USERNAME: 'username',
    SECRET: 'secret',
    API_KEY: 'api_key',
    STORE_API_KEY: 'store_api_key',
    SHIPMENT_UPDATE_STORE_URL: 'shipment_update_store_url',
    SHIPMENT_UPDATE_PATH: 'shipment_update_path',
    STORE_ID: 'store_id',
    EXTENSIV_STORE_URL: 'shipment_update_store_url',
    ORDERS_PREFIX: 'orders_prefix',
    TOKEN: 'token',
    REFRESH_TOKEN: 'refresh_token',
    SELLING_PARTNER_ID: 'selling_partner_id',
    SPAPI_OAUTH_CODE: 'spapi_oauth_code',
    MARKETPLACE: 'marketplace',
    ORDER_SUMMARY_SUBSCRIPTION: 'order_summary_subscription',
}
